export default "__VITE_PUBLIC_ASSET__c2d77818__"